import React from 'react';
import { TextField, useTranslate, type TextFieldProps, useRecordContext } from 'react-admin';

interface PaymentDateTextFieldProps extends TextFieldProps {
  source: string;
}

const PaymentDateTextField: React.FC<PaymentDateTextFieldProps> = (props) => {
  const { source, component } = props;
  const record = props.record || useRecordContext(props);
  const translate = useTranslate();

  if (!record) return null;

  const value = record[source];
  let translatedText;
  if (value === 99) {
    translatedText = translate('values.paymentDateEndOfMonth');
  } else {
    translatedText = translate('values.paymentDate', { day: value });
  }

  if (component === 'span') {
    return <>{translatedText}</>;
  }

  return <TextField {...props} source={source} record={{ ...record, [source]: translatedText }} />;
};

export default PaymentDateTextField;
